import { render, staticRenderFns } from "./VisitsCardWrapper.vue?vue&type=template&id=456c7256"
import script from "./VisitsCardWrapper.vue?vue&type=script&lang=ts"
export * from "./VisitsCardWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456c7256')) {
      api.createRecord('456c7256', component.options)
    } else {
      api.reload('456c7256', component.options)
    }
    module.hot.accept("./VisitsCardWrapper.vue?vue&type=template&id=456c7256", function () {
      api.rerender('456c7256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/VisitsCardWrapper.vue"
export default component.exports